import template from './ecocode-trustpilot-sales-channel-config.html.twig';

const { Mixin, Component } = Shopware;


Component.register('ecocode-trustpilot-sales-channel-config', {
    template,
    mixins: [
        Mixin.getByName('notification')
    ],
    methods: {
        save() {
            return this.$refs.systemConfig.saveAll();
        }
    },
    data() {
        return {
            config: {},
            actualConfigData: {}
        };
    }
});
